import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  NumberInput,
  coerceCssPixelValue,
  coerceNumberProperty,
} from '@angular/cdk/coercion';

@Component({
    selector: 'lui-indicator',
    imports: [CommonModule],
    templateUrl: './indicator.component.html',
    styleUrls: ['./indicator.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IndicatorComponent {
  @Input() get size(): NumberInput {
    return this._size;
  }
  set size(value: NumberInput) {
    if (value) {
      this._size = coerceNumberProperty(value);
    }
  }
  private _size = 64;

  @HostBinding('class') hostClass = 'lui-indicator';

  @HostBinding('style.--size') get sizeCssVariable() {
    return coerceCssPixelValue(this.size);
  }
}
